var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"reveal",class:_vm.getClassName},[_c('div',{ref:"inner",class:(_vm.getClassName + "__inner")},[_c('div',{ref:"img",class:(_vm.getClassName + "__img"),style:({ backgroundImage: ("url( " + _vm.img + " )") })})])])}
var staticRenderFns = []

export { render, staticRenderFns }